"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateExt = void 0;
var DateUtil_1 = require("@aelesia/commons/dist/src/collections/util/DateUtil");
var TimeUtil_1 = require("@aelesia/commons/dist/src/collections/util/TimeUtil");
function DateExt() {
    Date.prototype.utc = function () {
        return DateUtil_1.DateUtil.utc(this);
    };
    Date.prototype.epoch = function () {
        return DateUtil_1.DateUtil.epoch(this);
    };
    Date.prototype.timeUntil = function () {
        return TimeUtil_1.TimeUtil.until(this);
    };
    Date.prototype.timeSince = function () {
        return TimeUtil_1.TimeUtil.since(this);
    };
    Date.prototype.elapsed = function (date) {
        return TimeUtil_1.TimeUtil.elapsed(date, this);
    };
    Date.prototype.add = function (ms) {
        return DateUtil_1.DateUtil.add(ms, this);
    };
    Date.prototype.minus = function (ms) {
        return DateUtil_1.DateUtil.minus(ms, this);
    };
    Date.prototype.isBefore = function (date) {
        return DateUtil_1.DateUtil.isBefore(this, date);
    };
    Date.prototype.isAfter = function (date) {
        return DateUtil_1.DateUtil.isAfter(this, date);
    };
    Date.prototype.isPast = function () {
        return DateUtil_1.DateUtil.isPast(this);
    };
    Date.prototype.isFuture = function () {
        return DateUtil_1.DateUtil.isFuture(this);
    };
    Date.prototype._f = function (format) {
        return DateUtil_1.DateUtil._f(this, format);
    };
}
exports.DateExt = DateExt;
//# sourceMappingURL=DateExt.js.map